import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Locality, localityRequiredValidator } from './locality.model';

export type StreetType = 'CALLE' | 'AVENIDA' | 'PASAJE';

export interface Address {
    tipoCalle: StreetType;
    calle: string;
    codigoPostal: string;
    departamento?: string;
    fechaActualizacion?: string;
    fechaCreacion?: string;
    localidad: Locality;
    numero: string;
    piso?: string;
}

export function generateAddressFG() {
    return new UntypedFormGroup({
        tipoCalle: new UntypedFormControl('CALLE', [Validators.required]),
        calle: new UntypedFormControl('', [Validators.required]),
        numero: new UntypedFormControl('', [Validators.required]),
        piso: new UntypedFormControl('', []),
        departamento: new UntypedFormControl('', []),
        codigoPostal: new UntypedFormControl('', [Validators.required]),
        localidad: new UntypedFormControl('', [localityRequiredValidator]),
    });
}
